import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h1 m-0" }
const _hoisted_2 = { class: "invitations" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_5 = { class: "invitations-items" }
const _hoisted_6 = {
  key: 2,
  class: "small-text empty-state-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InviteElement = _resolveComponent("InviteElement")!
  const _component_ModalLayout = _resolveComponent("ModalLayout")!

  return (_openBlock(), _createBlock(_component_ModalLayout, { "has-close-button": true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('modals.invitations.invitations')), 1),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasTeam)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('modals.invitations.has_team')), 1))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invites, (invite) => {
            return (_openBlock(), _createBlock(_component_InviteElement, {
              key: invite,
              invite: invite,
              hasTeam: _ctx.hasTeam,
              onRefreshHomePage: _ctx.refreshHomePage,
              onChangeError: _ctx.changeError
            }, null, 8, ["invite", "hasTeam", "onRefreshHomePage", "onChangeError"]))
          }), 128))
        ]),
        (_ctx.invites.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('modals.invitations.no_invitations')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}